import React from 'react'
import { Routes, Route } from 'react-router-dom'
import styles from './App.module.css'
import Nav from './components/layout/Nav'
import Footer from './components/layout/Footer'
import Home from './pages/Home'
import LinkInput from './pages/LinkInput'
import SelectType from './pages/SelectType'
import SelectMethod from './pages/SelectMethod'
import Capture from './pages/Capture'
import Preview from './pages/Preview'
import Finish from './pages/Finish'
import Connect from './pages/Connect'
import Receive from './pages/Receive'
import Terms from './pages/Terms'
import Privacy from './pages/Privacy'

export default function App() {
  return (
    <div className={styles.layout}>
      <Nav />
      <div className={styles.content} style={{ paddingTop: '70px' }}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/link" element={<LinkInput />} />
          <Route path="/select-type" element={<SelectType />} />
          <Route path="/select-method" element={<SelectMethod />} />
          <Route path="/capture" element={<Capture />} />
          <Route path="/preview" element={<Preview />} />
          <Route path="/finish" element={<Finish />} />
          <Route path="/connect" element={<Connect />} />
          <Route path="/receive" element={<Receive />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
        </Routes>
      </div>
      <Footer />
    </div>
  )
}
